<template>

  <body>
    <c-theme-provider>
      <c-reset />
      <div id="app">
        <header ref="header">
          <c-flex justify="space-between" align="center">
            <c-flex gap="4px">
              <a class="logo" href="https://design-system-web.netlify.app">Design System</a>
              <c-badge color="#404040" bg="#e7e7e7" h="18px">DEMO</c-badge>
            </c-flex>
            <c-flex marginRight="56px">
              <span :class="['nav - router', 'button-nav', 'active', { 'nav-active': index == 0 }]"
                @click="toggleMode(0)">Code</span>
              <span :class="['nav - router', 'button-nav', 'active', { 'nav-active': index == 1 }]"
                @click="toggleMode(1)">Design</span>
            </c-flex>
          </c-flex>
          <c-divider class="header-divider" />
        </header>
        <!-- header zindex -->
        <router-view @open="setIndex"/>
      </div>
    </c-theme-provider>
  </body>
</template>



<script lang="js">
import { CThemeProvider, CReset, CDivider, CFlex, CBadge } from "@chakra-ui/vue";


export default {
  name: "App",
  components: {
    CThemeProvider,
    CReset,
    CDivider,
    CFlex,
    CBadge
  },


  // 'Code' button in navbar refresh //
  data() {
    return {
      index: sessionStorage.getItem('index') ? Number(sessionStorage.getItem('index')) : 0,
    };
  },
  methods: {
    toggleMode(index) {
      this.index = index;
      if (index == 0) {
        this.$router.push('/')
      }
      else {
        this.$router.push('/des')
      }
    },

      // navbar zindex //
      setIndex(index) {
        this.$refs.header.style.zIndex = index;
      }

  },

  // 'Code' button in navbar refresh //
  watch: {
    index(newValue) {
      sessionStorage.setItem('index', newValue);
    }
  }

};



</script>



<style lang="scss">
@import '@/scss/styles.scss'
</style>
